<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <item :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child" :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>
  import path from 'path';
  import { isExternal } from '@/utils/validate';
  import Item from './Item';
  import AppLink from './Link';
  import FixiOSBug from './FixiOSBug';

  export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
      // route object
      item: {
        type: Object,
        required: true,
      },
      isNest: {
        type: Boolean,
        default: false,
      },
      basePath: {
        type: String,
        default: '',
      },
    },
    data() {
      this.onlyOneChild = null;
      return {};
    },
    mounted() {},
    methods: {
      hasOneShowingChild(children = [], parent) {
        if (!children) {
          children = [];
        }
        const showingChildren = children.filter((item) => {
          if (item.hidden) {
            return false;
          } else {
            // Temp set(will be used if only has one showing child)
            this.onlyOneChild = item;
            return true;
          }
        });

        // When there is only one child router, the child router is displayed by default
        if (showingChildren.length === 1) {
          return true;
        }

        // Show parent if there are no child router to display
        if (showingChildren.length === 0) {
          this.onlyOneChild = { ...parent, path: '', noShowingChildren: true };
          return true;
        }

        return false;
      },
      resolvePath(routePath, routeQuery) {
        if (isExternal(routePath)) {
          return routePath;
        }
        if (isExternal(this.basePath)) {
          return this.basePath;
        }
        if (routeQuery) {
          let query = JSON.parse(routeQuery);
          return { path: path.resolve(this.basePath, routePath), query: query };
        }
        return path.resolve(this.basePath, routePath);
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep .menu-content li {
    margin: 0 !important;
  }
  .nest-menu {
    background-color: #1e78e7 !important;
    margin: 5px auto;
  }
  .nest-menu a {
    background-color: #1e78e7 !important;
    display: flex;
    &.router-link-active {
      border-radius: 8px;
    }
    &:last-child {
      border-radius: 0 0 8px 8px !important;
    }
  }
  .el-submenu,
  ::v-deep .el-submenu__title {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .nest-menu:last-child {
    border-radius: 8px !important;
  }
  .nest-menu a li {
    margin: 0 8px;
    box-sizing: border-box;
    font-weight: normal;
    background-color: #1e78e7 !important;
    svg {
      color: #fff;
    }
    /* margin: 0 8px !important; */
    .el-submenu__title,
    &:hover {
      background-color: rgba(255, 255, 255, 0.5) !important;
      border-radius: 8px !important;
      font-weight: normal !important;
    }
    &::before {
      font-weight: bold !important;
      content: '';
      position: absolute;
      left: 12px;
      top: 50%; /* 改为50% */
      transform: translateY(-50%); /* 垂直居中偏移 */
      width: 5px;
      height: 5px;
      background-color: #fff;
      border-radius: 5px;
    }
    &.is-active {
      display: flex;
      color: rgba(48, 135, 238, 1) !important;
      background-color: #fff !important;
      border-radius: 8px !important;
      font-weight: bold;
      &::before {
        font-weight: bold !important;
        content: '';
        position: absolute;
        left: 12px;
        width: 4px;
        height: calc(100% - 30px);
        background-color: rgba(13, 110, 254, 1);
        border-radius: 4px;
        top: 50%; /* 改为50% */
        transform: translateY(-50%); /* 垂直居中偏移 */
      }
    }
  }
</style>
